import type { Action } from "redux";

const SENSITIVE_ARG_KEYS = [
  "password",
  "confirmPassword",
  "oldPassword",
  "newPassword",
] as const;

function sanitizeThunkArg(arg: unknown): unknown {
  if (!arg || typeof arg !== "object") {
    return arg;
  }
  const obj = arg as Record<string, unknown>;
  let changed = false;
  const next = { ...obj };
  for (const key of SENSITIVE_ARG_KEYS) {
    if (key in next && typeof next[key] === "string") {
      next[key] = "***";
      changed = true;
    }
  }
  return changed ? next : arg;
}

/**
 * Masks credential fields in `meta.arg` for Redux DevTools (async thunk pending actions).
 */
export function sanitizeReduxActionForDevtools<ActionType extends Action>(action: ActionType): ActionType {
  if (!action || typeof action !== "object") {
    return action;
  }
  const actionObject = action as ActionType & { meta?: { arg?: unknown } };
  const meta = actionObject.meta;
  if (!meta || !("arg" in meta)) {
    return action;
  }
  const sanitizedArg = sanitizeThunkArg(meta.arg);
  if (sanitizedArg === meta.arg) {
    return action;
  }
  return {
    ...actionObject,
    meta: {
      ...meta,
      arg: sanitizedArg,
    },
  } as ActionType;
}
